import React, { useState } from 'react';
import styled from 'styled-components';
import { FormField, Button, ButtonGroup } from './FormElements';

const FormContainer = styled.div`
  width: 100%;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.text};
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
  margin: 0 0 2rem;
`;

const CompanyDataScreen = ({ formData, updateFormData, nextStep, prevStep }) => {
  const [errors, setErrors] = useState({});

  const sanitizeCNPJ = (value = '') => value.replace(/[^\d]/g, '');

  const validateCNPJ = (value) => {
    const cleaned = sanitizeCNPJ(value);

    if (cleaned.length !== 14) return false;
    if (/^(\d)\1{13}$/.test(cleaned)) return false;

    let size = cleaned.length - 2;
    let numbers = cleaned.substring(0, size);
    const digits = cleaned.substring(size);
    let sum = 0;
    let pos = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += parseInt(numbers.charAt(size - i), 10) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0), 10)) return false;

    size += 1;
    numbers = cleaned.substring(0, size);
    sum = 0;
    pos = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += parseInt(numbers.charAt(size - i), 10) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return result === parseInt(digits.charAt(1), 10);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'website') {
      let processedValue = value.trim();

      if (processedValue && !processedValue.startsWith('https://') && !processedValue.startsWith('http://')) {
        processedValue = `https://${processedValue}`;
      }

      processedValue = processedValue.replace(/^https?:\/\/https?:\/\//, 'https://');
      updateFormData({ [name]: processedValue });
    } else {
      updateFormData({ [name]: value });
    }

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.nome_fantasia) {
      newErrors.nome_fantasia = 'Informe o nome fantasia da empresa';
    } else if (formData.nome_fantasia.length < 3 || formData.nome_fantasia.length > 120) {
      newErrors.nome_fantasia = 'Use entre 3 e 120 caracteres';
    }

    if (formData.website && !/^https?:\/\/.+/.test(formData.website)) {
      newErrors.website = 'Informe uma URL válida (com http:// ou https://)';
    }

    if (!formData.cnpj) {
      newErrors.cnpj = 'O CNPJ é obrigatório';
    } else if (!validateCNPJ(formData.cnpj)) {
      newErrors.cnpj = 'Digite um CNPJ válido';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    nextStep();
  };

  return (
    <FormContainer>
      <Title>Sobre a empresa</Title>
      <Description>
        Informe os dados oficiais da empresa para que possamos identificar sua organização junto ao SETIRN.
      </Description>
      <form onSubmit={handleSubmit}>
        <FormField
          label="Nome da Empresa"
          name="nome_fantasia"
          placeholder="Digite o nome fantasia"
          value={formData.nome_fantasia}
          onChange={handleChange}
          error={errors.nome_fantasia}
        />

        <FormField
          label="Site da empresa"
          name="website"
          type="url"
          placeholder="https://suaempresa.com.br"
          value={formData.website || ''}
          onChange={handleChange}
          error={errors.website}
        />

        <FormField
          label="CNPJ"
          name="cnpj"
          placeholder="Digite o CNPJ"
          value={formData.cnpj}
          onChange={handleChange}
          error={errors.cnpj}
          mask="99.999.999/9999-99"
        />

        <ButtonGroup>
          <Button type="button" onClick={prevStep}>
            Voltar
          </Button>
          <Button type="submit" primary>
            Avançar
          </Button>
        </ButtonGroup>
      </form>
    </FormContainer>
  );
};

export default CompanyDataScreen;
